export default function account() {
    const accountFormInfo = document.querySelector('.js-account-form-info');
    const accountFormPass = document.querySelector('.js-account-form-pass');
    const nameInputs = document.querySelectorAll('.js-account-form-info-name');
    let currentPassword = 'qwerty'; // Текущий пароль по умолчанию
    console.log('currentPassword', currentPassword);

    // Функция для переключения режима редактирования
    function toggleEditMode(form, isPasswordForm = false, forceClose = false) {
        const inputs = form.querySelectorAll('input[data-edit]');
        const submitBtn = form.querySelector('button[type="submit"]');
        const isEditing = forceClose ? false : form.classList.toggle('edit');
        
        inputs.forEach(input => {
            if (isEditing && !forceClose) {
                input.removeAttribute('readonly');
                if (isPasswordForm && input.type === 'password') {
                    input.dataset.originalType = 'password';
                    input.type = 'text';
                    if (input.name !== 'account-pass-old') {
                        input.value = ''; // Очищаем только новые пароли
                    }
                }
            } else {
                input.setAttribute('readonly', '');
                if (isPasswordForm && input.dataset.originalType) {
                    input.type = input.dataset.originalType;
                    delete input.dataset.originalType;
                }
            }
        });
        
        if (submitBtn) {
            submitBtn.textContent = isEditing && !forceClose ? 'Сохранить изменения' : 
                                  (isPasswordForm ? 'Изменить пароль' : 'Изменить данные');
        }
    }

    // Функция валидации формы пароля
    function validatePasswordForm(form) {
        const oldPassInput = form.querySelector('input[name="account-pass-old"]');
        const newPassInput = form.querySelector('input[name="account-pass-new"]');
        const repeatPassInput = form.querySelector('input[name="account-pass-repeat"]');
        
        // Проверка старого пароля
        if (oldPassInput.value !== currentPassword) {
            oldPassInput.setCustomValidity('Неверный старый пароль');
            oldPassInput.reportValidity();
            return false;
        } else {
            oldPassInput.setCustomValidity('');
        }
        
        // Проверка совпадения новых паролей
        if (newPassInput.value !== repeatPassInput.value) {
            repeatPassInput.setCustomValidity('Пароли не совпадают');
            repeatPassInput.reportValidity();
            return false;
        } else {
            repeatPassInput.setCustomValidity('');
        }
        
        return true;
    }

    // Обработка основной формы
    if (accountFormInfo) {
        accountFormInfo.addEventListener('submit', function(e) {
            e.preventDefault();
            
            if (this.classList.contains('edit')) {
                toggleEditMode(this);
                nameInputs.forEach(input => input.setAttribute('readonly', ''));
            } else {
                toggleEditMode(this);
                nameInputs.forEach(input => input.removeAttribute('readonly'));
            }
        });
    }

    // Обработка формы пароля
    if (accountFormPass) {
        // Сброс валидации при изменении полей
        accountFormPass.querySelectorAll('input').forEach(input => {
            input.addEventListener('input', function() {
                this.setCustomValidity('');
            });
        });

        // Обработка отправки формы
        accountFormPass.addEventListener('submit', function(e) {
            e.preventDefault();
            
            if (this.classList.contains('edit')) {
                if (validatePasswordForm(this)) {
                    // Сохраняем новый пароль
                    currentPassword = this.querySelector('input[name="account-pass-new"]').value;
                    console.log('currentPassword', currentPassword);
                    
                    // Очищаем поля нового пароля
                    this.querySelector('input[name="account-pass-old"]').value = '';
                    this.querySelector('input[name="account-pass-new"]').value = '';
                    this.querySelector('input[name="account-pass-repeat"]').value = '';
                    
                    // Закрываем редактирование
                    this.classList.remove('edit');
                    toggleEditMode(this, true, true);
                }
            } else {
                // Открываем редактирование
                toggleEditMode(this, true);
            }
        });

        // Обработка кнопки отмены
        const cancelBtn = accountFormPass.querySelector('.account__form-cancel');
        if (cancelBtn) {
            cancelBtn.addEventListener('click', function() {
                const form = this.closest('form');
                form.querySelectorAll('input').forEach(input => {
                    input.value = '';
                    input.setCustomValidity('');
                });
                form.classList.remove('edit'); // Убираем класс edit
                toggleEditMode(form, true, true);
            });
        }
    }
}